if(!customElements.get('custom-map')){
    class CustomMap extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.mapWrapper = this.querySelector('#map-canvas');
            this.mapKey = this.mapWrapper.dataset.mapKey;
            this.mapAddress = this.mapWrapper.dataset.mapAddress;
            this.mapAddressEncoded = this.mapWrapper.dataset.mapAddressEncoded;
            this.mapColors = {
                water: this.mapWrapper.dataset.colorWater,
                landscape: this.mapWrapper.dataset.colorLandscape,
                highway: this.mapWrapper.dataset.colorHighway,
                arterial: this.mapWrapper.dataset.colorArterial,
                localRoad: this.mapWrapper.dataset.colorLocalRoad,
                poi: this.mapWrapper.dataset.colorPoi,
                park: this.mapWrapper.dataset.colorPark,
                transit: this.mapWrapper.dataset.colorTransit,
                administrative: this.mapWrapper.dataset.colorAdministrative,
                text: this.mapWrapper.dataset.colorText,
                textOutline: this.mapWrapper.dataset.colorOutlineText
            }
            this.pinColors = {
                outline: this.mapWrapper.dataset.colorPinOutline,
                fill: this.mapWrapper.dataset.colorPin
            }

            this.initMap();
        }

        initMap(){
            var script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${this.mapKey}&callback=initMap`;
            script.async = true;

            // attach your callback function to the 'window' object
            window.initMap = () => {
                this.geocoder = new google.maps.Geocoder();
                this.codeAddress();
            }

            document.head.appendChild(script);
        }

        codeAddress(){
            var address = this.mapAddress;
            var directionsDisplay;
            var directionsService = new google.maps.DirectionsService();
            directionsDisplay = new google.maps.DirectionsRenderer({
                draggable: true
            });

            this.geocoder.geocode({'address': address}, (results, status) => {
                if(status = 'OK' && results != null){
                    this.map = new google.maps.Map(this.mapWrapper, {
                        center: results[0].geometry.location,
                        zoom: 13,
                        maxZoom: 16,
                        mapTypeControl: false,
                        scrollwheel: false,
                        fullscreenControl: false,
                        streetViewControl: false,
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        panControlOptions: {
                            position: google.maps.ControlPosition.TOP_RIGHT
                        },
                        zoomControlOptions: {
                            position: google.maps.ControlPosition.TOP_RIGHT
                        },
                        styles: [
                            {
                                "featureType": "water",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": this.mapColors.water
                                    }
                                ]
                            },
                            {
                                "featureType": "landscape",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": this.mapColors.landscape
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    {
                                        "color": this.mapColors.highway
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    {
                                        "color": this.mapColors.highway
                                    },
                                    {
                                        "weight": 0.2
                                    }
                                ]
                            },
                            {
                                "featureType": "road.arterial",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": this.mapColors.arterial
                                    }
                                ]
                            },
                            {
                                "featureType": "road.local",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": this.mapColors.localRoad
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": this.mapColors.poi
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": this.mapColors.park
                                    }
                                ]
                            },
                            {
                                "elementType": "labels.icon",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    }
                                ]
                            },
                            {
                                "featureType": "transit",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": this.mapColors.transit
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    {
                                        "color": this.mapColors.administrative
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    {
                                        "color": this.mapColors.administrative
                                    },
                                    {
                                        "weight": 1.2
                                    }
                                ]
                            },
                            {
                                "elementType": "labels.text.stroke",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    },
                                    {
                                        "color": this.mapColors.textOutline
                                    }
                                ]
                            },
                            {
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": this.mapColors.text
                                    }
                                ]
                            }
                        ]
                    });

                    var template = [
                        '<?xml version="1.0"?>',
                        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">',
                            `<path stroke-linecap="round" fill="${this.pinColors.fill}" stroke="${this.pinColors.outline}" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />`,
                        '</svg>'
                    ].join('\n');

                    var svg = template;

                    this.marker = new google.maps.Marker({
                        map: this.map,
                        position: results[0].geometry.location,
                        icon: { url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg), scaledSize: new google.maps.Size(40, 40) }
                    });

                    google.maps.event.addListener(this.marker, 'mouseover', function(){
                        this.setIcon({ url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg), scaledSize: new google.maps.Size(50, 50) })
                    });

                    google.maps.event.addListener(this.marker, 'mouseout', function(){
                        this.setIcon({ url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg), scaledSize: new google.maps.Size(40, 40) })
                    });

                    google.maps.event.addListener(this.marker, 'click', () => {
                        window.open(`//maps.google.com/maps?saddr=My+Location&daddr=${this.mapAddressEncoded}`, '_blank');
                    });

                    new google.maps.event.addListenerOnce(this.map, 'idle', () => {
                        this.mapWrapper.setAttribute('data-loaded', 'true');
                    });

                    directionsDisplay.setMap(this.map);
                }else{
                    // error
                    if(status == 'OK'){

                    }else{
                        console.error('Geocode was not successful for the following reason: ', status);
                    }
                }
            })
        }
    }

    customElements.define('custom-map', CustomMap);
}